export default __webpack_public_path__ + "static/about-founder-d0b1c06dc4106b14317a37ff9d716679.webp";